/**
 * Hook logic menu người dùng trên header — mở/đóng, logout, quyền admin.
 *
 * Đóng menu khi scroll hoặc click bên ngoài.
 */
import { useCallback, useRef, useState } from 'react';
import { ADMIN_ROLES } from '../shared/constants/users';
import { useAuth } from './useAuth';
import { useCloseOnScroll } from '../shared/hooks/useCloseOnScroll';
import { useClickOutside } from '../shared/hooks/useClickOutside';
import { useLogoutAndRedirect } from './useLogoutAndRedirect';

/**
 * @returns {Object} Trạng thái menu user và handler logout
 */
export const useHeaderUserMenu = () => {
  const { user, isAuthenticated, isLoggingOut } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const closeMenu = useCallback(() => setIsMenuOpen(false), []);
  const handleLogout = useLogoutAndRedirect({ onBeforeLogout: closeMenu });

  useCloseOnScroll(isMenuOpen, closeMenu);
  useClickOutside(menuRef, isMenuOpen, closeMenu);

  return {
    user,
    isAuthenticated,
    isLoggingOut,
    isMenuOpen,
    setIsMenuOpen,
    menuRef,
    closeMenu,
    handleLogout,
    canAccessAdmin: ADMIN_ROLES.includes(user?.role),
  };
};
